import * as yup from 'yup'
import { MakeRequiredAndNullable } from './utils.js'

export enum FirstbaseRequestForQuoteLineItemKeys {
  lineNumber = 'lineNumber',
  itemName = 'itemName',
  mpn = 'mpn',
  quantity = 'quantity',
  unitCost = 'unitCost',
  shipmentCost = 'shipmentCost',
  tax = 'tax',
  total = 'total',
}

export const firstbaseRequestForQuoteFileDataSchema = yup.object().shape({
  issuer: yup.object().shape({
    attn: yup.string().nullable().optional(),
    companyName: yup.string().nullable().optional(),
    address: yup.string().nullable().optional(),
    phoneNumber: yup.string().nullable().optional(),
    emailAddress: yup.string().nullable().optional(),
  }),
  orderNumber: yup.string().nullable().optional(),
  dateIssued: yup.string().nullable().optional(),
  dateReady: yup.string().nullable().optional(),
  paymentTerms: yup.string().nullable().optional(),
  freightTerms: yup.string().nullable().optional(),
  destination: yup.object().shape({
    attn: yup.string().nullable().optional(),
    companyName: yup.string().nullable().optional(),
    address: yup.string().nullable().optional(),
    phoneNumber: yup.string().nullable().optional(),
    emailAddress: yup.string().nullable().optional(),
  }),
  vendor: yup.object().shape({
    attn: yup.string().nullable().optional(),
    companyName: yup.string().nullable().optional(),
    address: yup.string().nullable().optional(),
    phoneNumber: yup.string().nullable().optional(),
    emailAddress: yup.string().nullable().optional(),
  }),
  items: yup
    .array()
    .of(
      yup.object().shape({
        lineNumber: yup.number().nullable().optional(),
        itemName: yup.string().nullable().optional(),
        mpn: yup.string().nullable().optional(),
        quantity: yup.string().nullable().optional(),
        tax: yup.string().nullable().optional(),
        unitCost: yup.string().nullable().optional(),
        shipmentCost: yup.string().nullable().optional(),
        total: yup.string().nullable().optional(),
      }),
    )
    .required(),
  shippingCost: yup.string().nullable().optional(),
  tax: yup.string().nullable().optional(),
  total: yup.string().nullable().optional(),
  agreement: yup.string().nullable().optional(),
  instructions: yup.string().nullable().optional(),
})

export type FirstbaseRequestForQuoteFileData = yup.InferType<
  typeof firstbaseRequestForQuoteFileDataSchema
>
type RequiredFileData = MakeRequiredAndNullable<FirstbaseRequestForQuoteFileData>

export const firstbaseRequestForQuoteFileMappings: RequiredFileData = {
  issuer: {
    attn: '0b19c05a-a438-46f0-8005-176e502fb74f',
    companyName: '9b3b2d12-fbb6-414b-93e2-e2c0275e69ca',
    address: 'a8ee184d-3e3b-4b27-b21a-763999f055d6',
    phoneNumber: '2167dbb6-6e58-448f-ad0f-9b6b3d63975f',
    emailAddress: '59ece4d3-4875-4e49-88b2-0e1564c66383',
  },
  orderNumber: 'f5ca45d1-7990-4094-a55b-dfb1c01a21f1',
  paymentTerms: '1defcb53-489a-47ee-a699-b8db5004a160',
  freightTerms: '460fd186-f4f5-4df7-bd4c-9ed8ba9bdca7',
  dateIssued: '2114f711-2f87-4f91-a2f9-1d53b4790fcf',
  dateReady: '983dd07a-00f2-4f3a-ae71-2648c69b7928',
  destination: {
    attn: '68987a4d-bf6a-4ae8-984f-3edbb343c31f',
    companyName: '29bddb8f-9d1f-40ab-834f-2b385823b382',
    address: '03686156-0fb9-4cd8-9eae-4c3760f12ee8',
    phoneNumber: '460be5d6-1363-48fa-8129-1272d74b1f24',
    emailAddress: '0e7a1ddb-198e-4926-bc09-2abc6a7ce290',
  },
  vendor: {
    attn: 'cfb04509-90cc-4012-bfc9-8d8a3d7b7b07',
    companyName: '0eaa6719-c38a-41cc-aee2-ae93767de559',
    address: 'ce75f597-65c0-4162-8085-f6519af08b7e',
    phoneNumber: '8daf9e89-2885-4932-9eed-d9824ad9cff0',
    emailAddress: '0027da13-e0a8-4307-ab06-bf8710c952c3',
  },
  items: [
    {
      lineNumber: null,
      itemName: 'ae779d7f-8ae1-4dd7-b718-4c584c601558',
      mpn: '7d65519d-02bc-420e-92d7-1368c43e7b4c',
      quantity: '0936bb77-f340-4c68-aefb-26e913bee630',
      tax: 'cd65d7b1-2e86-449f-922f-a504e024809f',
      unitCost: '0b1a8878-032c-4f73-8e12-82f3e9918d0c',
      shipmentCost: 'a80a86b2-95be-4b06-900d-431cc75e1c76',
      total: 'c07f1a36-2af5-4c48-b829-fe22fc74ea05',
    },
  ],
  shippingCost: '2c1c1abc-80b0-4120-b90b-c4c8b313b10c',
  tax: '291c569e-e881-4855-9844-6e5e8d1c4fb3',
  total: '016159a9-544d-4949-aa07-7ba92755ff3d',
  agreement: 'a79d64ae-d1a4-412c-bffe-975b94234a3a',
  instructions: 'a3f7d296-b608-47e0-bda0-27e8cb53b667',
}
